import { useState } from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { UserSelectorInput } from 'modules/core/components/Inputs/UserSelector'
import Modal from 'modules/core/components/Modal'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import useUpdateUploadProcessDocumentMutation from 'modules/documents/components/BulkFiles/useUpdateUploadProcessDocumentMutation'
import { UploadProcessDocument } from 'modules/documents/hooks/useGetUploadProcessDocuments'

interface Props {
  uploadProcessDocument?: UploadProcessDocument
  onClose: () => void
  onSignersUpdateFinished?: () => void
}

const SelectAdditionalSignersModal = ({
  uploadProcessDocument,
  onClose,
  onSignersUpdateFinished,
}: Props) => {
  const [selectedIds, setSelectedIds] = useState<number[]>([])

  useUnsafeEffect(() => {
    const documentSigners = uploadProcessDocument?.additionalSigners.map((signer) => signer.id)
    setSelectedIds(documentSigners ?? [])
  }, [uploadProcessDocument])

  const accessToDisplay = useUnsafeMemo(() => {
    return users.models.filter((user) => user.isActive && user.attributes.confirmed)
  }, [])

  const onUpdatedFinished = () => {
    onClose()
    onSignersUpdateFinished && onSignersUpdateFinished()
  }

  const { onSubmit, submitting } = useUpdateUploadProcessDocumentMutation({
    documentId: uploadProcessDocument?.documentId ?? 0,
    additionalSignersAccessIds: selectedIds,
    onUpdatedFinished: onUpdatedFinished,
  })

  const onSelectUsers = (userIds: number[]) => {
    setSelectedIds(userIds)
  }

  return (
    <Modal
      illustration="signature"
      title={i18n.t('split_documents.summary_widget.change_additional_signers_modal.title')}
      description={i18n.t(
        'split_documents.summary_widget.change_additional_signers_modal.description'
      )}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button type="primary" disabled={submitting} submit>
            {i18n.t('common.select')}
          </Button>
        </>
      }
    >
      <UserSelectorInput
        label={i18n.t('documents.beta.signees')}
        onSubmit={onSelectUsers}
        selectedIds={selectedIds}
        users={accessToDisplay}
      />
    </Modal>
  )
}

export default SelectAdditionalSignersModal
